import { Modal } from "antd";
import React from "react";
import { PropertyImgs } from "./PropertyImgs";

const PropertyImageModal = ({ item, handlePropertyImageCancel }) => {

  return (
    <>
      <Modal
        open={true}
        footer={false}
        onCancel={handlePropertyImageCancel}
        width={600}
        title={
         <div style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px", height: "0px" }}>Property Image</div>
        }
        style={{ maxHeight: "90%", marginTop:"-30px" }}
      >
        <div style={{display: "flex", justifyContent: "center", padding: "10% 20px"}}>
          <PropertyImgs currentlySelectedData={item}/>
        </div>
      </Modal>
    </>
  );
};

export { PropertyImageModal };
